// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"jn","result_page":"kn","what_are_calories":"ln","title":"mn","copy":"nn","chart":"on","to_reach":"pn","title_wrapper":"qn","rhode_percent":"rn","what_are_macro":"sn","text":"tn","img":"un","macros_wrapper":"vn","macros":"wn","macro_item":"xn","value":"yn","note":"zn","btn":"An","carbo_item":"Bn","faq":"Cn","faq_items":"En"};
    if(module.hot) {
      // 1726593103128
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  